import {gsap, SplitText} from "../LibrariesImport";
export default class BlockTextAnimated {
	static init() {

		let blocks = document.querySelectorAll('.block-text-animated');

		document.fonts.ready.then(() => {
			blocks.forEach( (block) => {

				const text = block.querySelector('.text-animated');
				const myText = new SplitText(text, {
					type: "words, chars"
				});

				const colorStart = getComputedStyle(block).getPropertyValue('--block-text-animated-text-color-start').trim();
				const colorEnd = getComputedStyle(block).getPropertyValue('--block-text-animated-text-color-end').trim();

				gsap.fromTo(myText.chars,
					{
						color: colorStart
					}, {
						color: colorEnd,
						scrollTrigger: {
							trigger: block,
							start: "top 80%",
							end: "bottom center",
							scrub: true
						},
						stagger: 0.02
					}
				);

			});
		});
	}
}
